import { FeatureGroup } from 'react-leaflet';
import { FeatureGroup as LeafletFeatureGroup } from 'leaflet';
import { pick } from 'lodash';

const OPTIONS = ['priority'];

/*
 * @TODO There are several things to sort out here still to make sure we know
 * what's going on.
 *
 * The onLeafletUpdate callback is used to get a hold of the leafletElement from
 * a parent. In a normal react world this would be done via ref, but these don't
 * work for leaflet apparently or it is broken in PriorityFeatureGroup. The ref
 * function of the PriorityFeatureGroup is called serveral times, but often also
 * with null. Also they seem to be called all the time for all children on hover
 * and other interactive states.
 *
 * The onLeafletUpdate callback is used to get the lat/lng bounds of the segments
 * it contains, once on creation time. Since these properties don't change later
 * the callback is not called in updateLeafletElement, for performance reasons,
 * but it could be if feasable.
 *
 * Anyway we have to make sure we understand how React and Leaflet play together
 * in this regard, and document why each of the functions below do what they do.
 */

const LeafletPriorityFeatureGroup = LeafletFeatureGroup.extend({
  initialize(layers) {
    // eslint-disable-next-line no-underscore-dangle
    this._layers = {};
    this.options = pick(layers, OPTIONS);

    if (layers) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < layers.length; i++) {
        this.addLayer(layers[i]);
      }
    }
  },
});

export default class PriorityFeatureGroup extends FeatureGroup {
  createLeafletElement(props) {
    const leafletElement = new LeafletPriorityFeatureGroup(this.getOptions(props));

    if (typeof props.onLeafletUpdate === 'function') {
      props.onLeafletUpdate(leafletElement);
    }

    return leafletElement;
  }

  updateLeafletElement(fromProps, toProps) {
    const layer = this.leafletElement;

    if (layer && layer.options) {
      layer.options = { ...layer.options, ...pick(toProps, OPTIONS) };
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/PriorityFeatureGroup/index.js